export const sources={};export const img={src:"__VITE_ASSET__eBB5uVE_t2Bb1etqpZE3Ig__",w:640,h:640};export default{sources:sources,img:img};